export default "__VITE_ASSET__abcbb08d__"